import h from "./html";
import Db from "./db";
import { PasswordReset } from "../../srv/bindings/PasswordReset";

export default function Admin({ db: _db }: { db: Db }) {
  let pwResets = h.state<"loading" | "error" | Array<PasswordReset>>("loading");
  fetch(`${process.env.SERVER_PATH}/admin/pw_resets`, {
    credentials: "include",
  }).then(async (res) => {
    const json = await res.json();
    pwResets.val = json;
  });
  return (
    <div className="flex flex-col">
      <h2 className="text-xl mb-2 font-bold">Password Resets</h2>
      <div className="mb-2">
        {() =>
          pwResets.val instanceof Array ? (
            <ul className="list-disc list-inside">
              {pwResets.val.map((reset) => (
                <li>
                  <a
                    href={`/reset/${reset.resetCode}`}
                    className="underline text-blue-400"
                  >
                    {reset.email}
                  </a>
                </li>
              ))}
            </ul>
          ) : (
            ""
          )
        }
      </div>
    </div>
  );
}
